// "use client"

// import { useState, useEffect } from "react"
// import {
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   LineChart,
//   Line,
//   AreaChart,
//   Area,
//   RadarChart,
//   Radar,
//   PolarGrid,
//   PolarAngleAxis,
//   PolarRadiusAxis,
//   ScatterChart,
//   Scatter,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts"
// import { motion, AnimatePresence } from "framer-motion"

// const Dashboard = () => {
//   const [paymentData, setPaymentData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)
//   const [activeTab, setActiveTab] = useState("overview")
//   const [mockData, setMockData] = useState(false)

//   // Gradient colors for charts
//   const GRADIENT_COLORS = {
//     blue: "#4158D0",
//     purple: "#C850C0",
//     pink: "#FFCC70",
//   }

//   // Define chart colors with gradients
//   const COLORS = ["#4158D0", "#C850C0", "#FFCC70", "#FF6B6B", "#4E65FF", "#FF9A8B"]

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true)
//         const response = await fetch("https://hsbubackend.tdtlworld.com/formdata/payment/")
//         if (!response.ok) {
//           throw new Error("Network response was not ok")
//         }
//         const data = await response.json()

//         // Check if data is empty or has issues
//         if (!data || data.length === 0) {
//           console.warn("API returned empty data, using mock data")
//           setMockData(true)
//           // Use the sample data provided by the user
//           setPaymentData([
//             {
//               order_id: "order_QMmBIsSl92KhBg",
//               payment_id: "pay_QMmBl6AxT3JQQL",
//               signature: "b7e793a9644a67ace26010b3e930df047fb0e5060333a098ae84e4b688e869d1",
//               amount: 118000,
//               verified: true,
//               created_at: "2025-04-24T05:17:44.211904Z",
//               mobile: null,
//               name: null,
//               email: null,
//               program_id: null,
//             },
//           ])
//         } else {
//           setPaymentData(data)
//         }
//         setLoading(false)
//       } catch (error) {
//         console.error("Error fetching data:", error)
//         setError(error.message)
//         setMockData(true)
//         // Use the sample data provided by the user
//         setPaymentData([
//           {
//             order_id: "order_QMmBIsSl92KhBg",
//             payment_id: "pay_QMmBl6AxT3JQQL",
//             signature: "b7e793a9644a67ace26010b3e930df047fb0e5060333a098ae84e4b688e869d1",
//             amount: 118000,
//             verified: true,
//             created_at: "2025-04-24T05:17:44.211904Z",
//             mobile: null,
//             name: null,
//             email: null,
//             program_id: null,
//           },
//         ])
//         setLoading(false)
//       }
//     }

//     fetchData()
//   }, [])

//   // Generate dates for the past week if we're using mock data
//   const generateMockDates = () => {
//     const dates = []
//     const today = new Date()

//     for (let i = 6; i >= 0; i--) {
//       const date = new Date(today)
//       date.setDate(today.getDate() - i)
//       dates.push(date.toISOString())
//     }

//     return dates
//   }

//   // Process data for charts
//   const processDataForCharts = () => {
//     if (mockData) {
//       // Generate mock data for charts with the sample payment
//       const mockDates = generateMockDates()
//       return mockDates.map((date, index) => {
//         // Create varying amounts based on the index
//         const amount = (paymentData[0].amount  ) * (0.5 + Math.random() * 0.8)
//         return {
//           date: new Date(date).toLocaleDateString(),
//           count: index === 3 ? 2 : 1, // Add a spike on day 3
//           totalAmount: amount,
//         }
//       })
//     }

//     // Group payments by date
//     const paymentsByDate = paymentData.reduce((acc, payment) => {
//       const date = new Date(payment.created_at).toLocaleDateString()
//       if (!acc[date]) {
//         acc[date] = { date, count: 0, totalAmount: 0 }
//       }
//       acc[date].count += 1
//       acc[date].totalAmount += payment.amount   // Convert to dollars/rupees
//       return acc
//     }, {})

//     // Convert to array for charts
//     return Object.values(paymentsByDate)
//   }

//   // Process data for pie chart (payment verification status)
//   const processDataForPieChart = () => {
//     const verifiedCount = paymentData.filter((payment) => payment.verified).length
//     const notVerifiedCount = paymentData.length - verifiedCount

//     return [
//       { name: "Verified", value: verifiedCount || 1 },
//       { name: "Not Verified", value: notVerifiedCount || 0 },
//     ]
//   }

//   // Process data for radar chart (payment amounts by category)
//   const processDataForRadarChart = () => {
//     // For demo purposes, we'll create categories based on amount ranges
//     const categories = {
//       "Small (<1000)": 0,
//       "Medium (1000-5000)": 0,
//       "Large (5000-10000)": 0,
//       "X-Large (>10000)": 0,
//     }

//     paymentData.forEach((payment) => {
//       const amount = payment.amount  
//       if (amount < 1000) {
//         categories["Small (<1000)"] += 1
//       } else if (amount < 5000) {
//         categories["Medium (1000-5000)"] += 1
//       } else if (amount < 10000) {
//         categories["Large (5000-10000)"] += 1
//       } else {
//         categories["X-Large (>10000)"] += 1
//       }
//     })

//     // Ensure we have at least one value in each category for mock data
//     if (mockData) {
//       categories["X-Large (>10000)"] = 1
//     }

//     return Object.keys(categories).map((key) => ({
//       subject: key,
//       A: categories[key],
//       fullMark: paymentData.length,
//     }))
//   }

//   // Process data for scatter chart
//   const processDataForScatterChart = () => {
//     if (mockData) {
//       // Generate mock scatter data
//       return Array.from({ length: 10 }, (_, i) => ({
//         x: i + 1,
//         y: (paymentData[0].amount  ) * (0.7 + Math.random() * 0.6),
//         z: Math.random() > 0.3 ? 200 : 100,
//       }))
//     }

//     return paymentData.map((payment, index) => ({
//       x: index + 1,
//       y: payment.amount  ,
//       z: payment.verified ? 200 : 100,
//     }))
//   }

//   // Calculate total revenue
//   const calculateTotalRevenue = () => {
//     return paymentData.reduce((total, payment) => total + payment.amount  , 0).toFixed(2)
//   }

//   // Calculate average transaction value
//   const calculateAverageTransaction = () => {
//     if (paymentData.length === 0) return 0
//     return (paymentData.reduce((total, payment) => total + payment.amount  , 0) / paymentData.length).toFixed(2)
//   }

//   // Format date for display
//   const formatDate = (dateString) => {
//     const options = { year: "numeric", month: "short", day: "numeric" }
//     return new Date(dateString).toLocaleDateString(undefined, options)
//   }

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount)
//   }

//   // Generate skeleton data for charts when loading
//   const generateSkeletonData = () => {
//     return Array.from({ length: 7 }, (_, i) => ({
//       date: `Day ${i + 1}`,
//       count: Math.floor(Math.random() * 3) + 1,
//       totalAmount: Math.floor(Math.random() * 5000) + 1000,
//     }))
//   }

//   // Generate skeleton data for pie chart
//   const generateSkeletonPieData = () => {
//     return [
//       { name: "Category 1", value: 60 },
//       { name: "Category 2", value: 40 },
//     ]
//   }

//   // Generate skeleton data for radar chart
//   const generateSkeletonRadarData = () => {
//     return [
//       { subject: "Category A", A: 80, fullMark: 150 },
//       { subject: "Category B", A: 120, fullMark: 150 },
//       { subject: "Category C", A: 60, fullMark: 150 },
//       { subject: "Category D", A: 100, fullMark: 150 },
//     ]
//   }

//   // Generate skeleton data for scatter chart
//   const generateSkeletonScatterData = () => {
//     return Array.from({ length: 10 }, (_, i) => ({
//       x: i + 1,
//       y: Math.floor(Math.random() * 5000) + 1000,
//       z: 100,
//     }))
//   }

//   // Generate skeleton rows for table
//   const generateSkeletonTableRows = () => {
//     return Array.from({ length: 5 }, (_, i) => ({
//       id: `skeleton-${i}`,
//       order_id: `ORD${100000 + i}`,
//       payment_id: `PAY${200000 + i}`,
//       amount: Math.floor(Math.random() * 100000) + 10000,
//       verified: Math.random() > 0.3,
//       created_at: new Date().toISOString(),
//       email: "user@example.com",
//     }))
//   }

//   if (loading) {
//     // Show skeleton UI while loading
//     const skeletonChartData = generateSkeletonData()
//     const skeletonPieData = generateSkeletonPieData()
//     const skeletonRadarData = generateSkeletonRadarData()
//     const skeletonScatterData = generateSkeletonScatterData()
//     const skeletonTableData = generateSkeletonTableRows()

//     return (
//       <div className="dashboard-container">
//         <header className="dashboard-header">
//           <div className="skeleton-text skeleton-title"></div>
//           <div className="skeleton-text skeleton-date"></div>
//         </header>

//         <div className="dashboard-tabs">
//           <div className="skeleton-tab"></div>
//           <div className="skeleton-tab"></div>
//           <div className="skeleton-tab"></div>
//         </div>

//         <div className="dashboard-stats">
//           {Array.from({ length: 4 }).map((_, index) => (
//             <div key={`stat-skeleton-${index}`} className="stat-card skeleton-card">
//               <div className="skeleton-text skeleton-label"></div>
//               <div className="skeleton-text skeleton-value"></div>
//               <div className="skeleton-text skeleton-description"></div>
//             </div>
//           ))}
//         </div>

//         <div className="charts-container">
//           {/* Skeleton Bar Chart */}
//           <div className="chart-card skeleton-card">
//             <div className="skeleton-text skeleton-chart-title"></div>
//             <div className="chart-container skeleton-chart">
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={skeletonChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                   <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
//                   <XAxis dataKey="date" stroke="rgba(255,255,255,0.3)" />
//                   <YAxis stroke="rgba(255,255,255,0.3)" />
//                   <Tooltip />
//                   <Bar dataKey="count" fill="rgba(255,255,255,0.2)" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* Skeleton Line Chart */}
//           <div className="chart-card skeleton-card">
//             <div className="skeleton-text skeleton-chart-title"></div>
//             <div className="chart-container skeleton-chart">
//               <ResponsiveContainer width="100%" height={300}>
//                 <LineChart data={skeletonChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                   <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
//                   <XAxis dataKey="date" stroke="rgba(255,255,255,0.3)" />
//                   <YAxis stroke="rgba(255,255,255,0.3)" />
//                   <Line type="monotone" dataKey="totalAmount" stroke="rgba(255,255,255,0.3)" dot={false} />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* Skeleton Pie Chart */}
//           <div className="chart-card skeleton-card">
//             <div className="skeleton-text skeleton-chart-title"></div>
//             <div className="chart-container skeleton-chart">
//               <ResponsiveContainer width="100%" height={300}>
//                 <PieChart>
//                   <Pie
//                     data={skeletonPieData}
//                     cx="50%"
//                     cy="50%"
//                     outerRadius={80}
//                     fill="rgba(255,255,255,0.2)"
//                     dataKey="value"
//                   />
//                 </PieChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* Skeleton Area Chart */}
//           <div className="chart-card skeleton-card">
//             <div className="skeleton-text skeleton-chart-title"></div>
//             <div className="chart-container skeleton-chart">
//               <ResponsiveContainer width="100%" height={300}>
//                 <AreaChart data={skeletonChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                   <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
//                   <XAxis dataKey="date" stroke="rgba(255,255,255,0.3)" />
//                   <YAxis stroke="rgba(255,255,255,0.3)" />
//                   <Area type="monotone" dataKey="totalAmount" stroke="rgba(255,255,255,0.3)" fill="rgba(255,255,255,0.1)" />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* Skeleton Radar Chart */}
//           <div className="chart-card skeleton-card">
//             <div className="skeleton-text skeleton-chart-title"></div>
//             <div className="chart-container skeleton-chart">
//               <ResponsiveContainer width="100%" height={300}>
//                 <RadarChart outerRadius={90} data={skeletonRadarData}>
//                   <PolarGrid stroke="rgba(255,255,255,0.1)" />
//                   <PolarAngleAxis dataKey="subject" stroke="rgba(255,255,255,0.3)" />
//                   <Radar name="Skeleton" dataKey="A" stroke="rgba(255,255,255,0.3)" fill="rgba(255,255,255,0.1)" fillOpacity={0.6} />
//                 </RadarChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* Skeleton Scatter Chart */}
//           <div className="chart-card skeleton-card">
//             <div className="skeleton-text skeleton-chart-title"></div>
//             <div className="chart-container skeleton-chart">
//               <ResponsiveContainer width="100%" height={300}>
//                 <ScatterChart margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                   <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
//                   <XAxis type="number" dataKey="x" name="Index" stroke="rgba(255,255,255,0.3)" />
//                   <YAxis type="number" dataKey="y" name="Amount" stroke="rgba(255,255,255,0.3)" />
//                   <Scatter name="Skeleton" data={skeletonScatterData} fill="rgba(255,255,255,0.3)" />
//                 </ScatterChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </div>

//         <div className="table-section skeleton-card">
//           <div className="skeleton-text skeleton-table-title"></div>
//           <div className="table-container">
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Order ID</th>
//                   <th>Payment ID</th>
//                   <th>Amount</th>
//                   <th>Status</th>
//                   <th>Date</th>
//                   <th>Email</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {skeletonTableData.map((row, index) => (
//                   <tr key={`skeleton-row-${index}`} className="skeleton-row">
//                     <td><div className="skeleton-cell"></div></td>
//                     <td><div className="skeleton-cell"></div></td>
//                     <td><div className="skeleton-cell"></div></td>
//                     <td><div className="skeleton-badge"></div></td>
//                     <td><div className="skeleton-cell"></div></td>
//                     <td><div className="skeleton-cell"></div></td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="loading-overlay">
//           <div className="loading-spinner"></div>
//           <p>Loading dashboard data...</p>
//         </div>

//         <style jsx>{`
//           /* Dashboard Styles */
//           .dashboard-container {
//             font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//             max-width: 1400px;
//             margin: 0 auto;
//             padding: 20px;
//             background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
//             color: #fff;
//             min-height: 100vh;
//             position: relative;
//           }

//           .dashboard-header {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             margin-bottom: 30px;
//             padding-bottom: 15px;
//             border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//           }

//           .dashboard-tabs {
//             display: flex;
//             margin-bottom: 25px;
//             border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//           }

//           .skeleton-tab {
//             width: 100px;
//             height: 40px;
//             background: rgba(255, 255, 255, 0.1);
//             margin-right: 10px;
//             border-radius: 4px;
//           }

//           .dashboard-stats {
//             display: grid;
//             grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
//             gap: 20px;
//             margin-bottom: 30px;
//           }

//           .skeleton-card {
//             background: rgba(255, 255, 255, 0.05);
//             border-radius: 15px;
//             padding: 20px;
//             border: 1px solid rgba(255, 255, 255, 0.1);
//             position: relative;
//             overflow: hidden;
//           }

//           .skeleton-card::after {
//             content: "";
//             position: absolute;
//             top: 0;
//             right: 0;
//             bottom: 0;
//             left: 0;
//             transform: translateX(-100%);
//             background-image: linear-gradient(
//               90deg,
//               rgba(255, 255, 255, 0) 0,
//               rgba(255, 255, 255, 0.05) 20%,
//               rgba(255, 255, 255, 0.1) 60%,
//               rgba(255, 255, 255, 0)
//             );
//             animation: shimmer 2s infinite;
//           }

//           @keyframes shimmer {
//             100% {
//               transform: translateX(100%);
//             }
//           }

//           .skeleton-text {
//             height: 14px;
//             background: rgba(255, 255, 255, 0.1);
//             border-radius: 4px;
//             margin-bottom: 10px;
//           }

//           .skeleton-title {
//             width: 300px;
//             height: 32px;
//           }

//           .skeleton-date {
//             width: 150px;
//             height: 14px;
//           }

//           .skeleton-label {
//             width: 70%;
//             height: 16px;
//           }

//           .skeleton-value {
//             width: 50%;
//             height: 28px;
//             margin-top: 10px;
//           }

//           .skeleton-description {
//             width: 60%;
//             height: 14px;
//             margin-top: 10px;
//           }

//           .skeleton-chart-title {
//             width: 200px;
//             height: 18px;
//             margin-bottom: 20px;
//           }

//           .skeleton-table-title {
//             width: 200px;
//             height: 22px;
//             margin-bottom: 20px;
//           }

//           .charts-container {
//             display: grid;
//             grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
//             gap: 20px;
//             margin-bottom: 30px;
//           }

//           @media (max-width: 768px) {
//             .charts-container {
//               grid-template-columns: 1fr;
//             }
//           }

//           .chart-container {
//             height: 300px;
//           }

//           .skeleton-chart {
//             opacity: 0.5;
//           }

//           .skeleton-row {
//             height: 50px;
//           }

//           .skeleton-cell {
//             height: 14px;
//             background: rgba(255, 255, 255, 0.1);
//             border-radius: 4px;
//             width: 80%;
//           }

//           .skeleton-badge {
//             height: 24px;
//             width: 80px;
//             background: rgba(255, 255, 255, 0.1);
//             border-radius: 12px;
//           }

//           .loading-overlay {
//             position: absolute;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(15, 12, 41, 0.7);
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: center;
//             z-index: 10;
//             backdrop-filter: blur(5px);
//           }

//           .loading-spinner {
//             border: 4px solid rgba(255, 255, 255, 0.1);
//             width: 40px;
//             height: 40px;
//             border-radius: 50%;
//             border-left-color: #C850C0;
//             border-top-color: #4158D0;
//             animation: spin 1s linear infinite;
//             margin-bottom: 20px;
//           }

//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }

//           .data-table {
//             width: 100%;
//             border-collapse: collapse;
//             font-size: 14px;
//             color: #fff;
//           }

//           .data-table th {
//             background: rgba(255, 255, 255, 0.1);
//             padding: 12px 15px;
//             text-align: left;
//             font-weight: 600;
//             color: #fff;
//             border-bottom: 2px solid rgba(255, 255, 255, 0.1);
//           }

//           .data-table td {
//             padding: 12px 15px;
//             border-bottom: 1px solid rgba(255, 255, 255, 0.05);
//           }
//         `}</style>
//       </div>
//     )
//   }

//   if (error && !mockData) {
//     return (
//       <div className="dashboard-container error">
//         <h2>Error loading data</h2>
//         <p>{error}</p>
//         <button onClick={() => window.location.reload()}>Try Again</button>

//         <style jsx>{`
//           .dashboard-container {
//             font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//             max-width: 1400px;
//             margin: 0 auto;
//             padding: 20px;
//             background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
//             color: #fff;
//             min-height: 100vh;
//           }

//           .error {
//             text-align: center;
//             padding: 50px;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: center;
//             height: 100vh;
//           }

//           .error h2 {
//             font-size: 28px;
//             margin-bottom: 20px;
//             background: linear-gradient(to right, #4158D0, #C850C0);
//             -webkit-background-clip: text;
//             -webkit-text-fill-color: transparent;
//           }

//           .error p {
//             margin-bottom: 30px;
//             font-size: 18px;
//             max-width: 600px;
//           }

//           .error button {
//             background: linear-gradient(to right, #4158D0, #C850C0);
//             color: white;
//             border: none;
//             padding: 12px 24px;
//             border-radius: 30px;
//             cursor: pointer;
//             font-size: 16px;
//             font-weight: 600;
//             transition: all 0.3s ease;
//             box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
//           }

//           .error button:hover {
//             transform: translateY(-2px);
//             box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
//           }
//         `}</style>
//       </div>
//     )
//   }

//   const chartData = processDataForCharts()
//   const pieChartData = processDataForPieChart()
//   const radarChartData = processDataForRadarChart()
//   const scatterChartData = processDataForScatterChart()

//   return (
//     <div className="dashboard-container">
//       <header className="dashboard-header">
//         <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//           Payment Analytics Dashboard
//         </motion.h1>
//         <div className="date-range">
//           <span>Last Updated: {new Date().toLocaleString()}</span>
//         </div>
//       </header>

//       <div className="dashboard-tabs">
//         <button className={activeTab === "overview" ? "active" : ""} onClick={() => setActiveTab("overview")}>
//           Overview
//         </button>
//         <button className={activeTab === "transactions" ? "active" : ""} onClick={() => setActiveTab("transactions")}>
//           Transactions
//         </button>
//         <button className={activeTab === "analytics" ? "active" : ""} onClick={() => setActiveTab("analytics")}>
//           Analytics
//         </button>
//       </div>

//       <div className="dashboard-stats">
//         {[
//           { title: "Total Transactions", value: paymentData.length, description: "All time payments" },
//           { title: "Total Revenue", value: formatCurrency(calculateTotalRevenue()), description: "All time revenue" },
//           { title: "Average Transaction", value: formatCurrency(calculateAverageTransaction()), description: "Per transaction" },
//           { 
//             title: "Verification Rate", 
//             value: paymentData.length
//               ? `${((paymentData.filter((p) => p.verified).length / paymentData.length) * 100).toFixed(1)}%`
//               : "0%", 
//             description: "Successfully verified" 
//           }
//         ].map((stat, index) => (
//           <motion.div
//             key={`stat-${index}`}
//             className="stat-card"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: index * 0.1 }}
//             whileHover={{ y: -5 }}
//             style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//           >
//             <h3>{stat.title}</h3>
//             <p className="stat-value">{stat.value}</p>
//             <p className="stat-description">{stat.description}</p>
//           </motion.div>
//         ))}
//       </div>

//       <div className="charts-container">
//         {/* Chart 1: Bar Chart - Payment Counts by Date */}
//         <motion.div
//           className="chart-card"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.5 }}
//           whileHover={{ y: -5 }}
//           style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//         >
//           <h3>Payment Counts by Date</h3>
//           <div className="chart-container">
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                 <defs>
//                   <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.8} />
//                     <stop offset="100%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.8} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharrayray="3 3" stroke="rgba(255,255,255,0.2)" />
//                 <XAxis dataKey="date" stroke="#fff" />
//                 <YAxis stroke="#fff" />
//                 <Tooltip
//                   contentStyle={{
//                     backgroundColor: "rgba(0,0,0,0.8)",
//                     border: "none",
//                     borderRadius: "5px",
//                     color: "#fff",
//                   }}
//                   formatter={(value) => [`${value}`, "Count"]}
//                 />
//                 <Legend />
//                 <Bar
//                   dataKey="count"
//                   fill="url(#barGradient)"
//                   name="Number of Payments"
//                   animationDuration={2000}
//                   animationBegin={300}
//                   animationEasing="ease-in-out"
//                   radius={[5, 5, 0, 0]}
//                 />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>

//         {/* Chart 2: Line Chart - Payment Amounts Over Time */}
//         <motion.div
//           className="chart-card"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.5, delay: 0.1 }}
//           whileHover={{ y: -5 }}
//           style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//         >
//           <h3>Payment Amounts Over Time</h3>
//           <div className="chart-container">
//             <ResponsiveContainer width="100%" height={300}>
//               <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                 <defs>
//                   <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.purple} stopOpacity={1} />
//                     <stop offset="100%" stopColor={GRADIENT_COLORS.pink} stopOpacity={1} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
//                 <XAxis dataKey="date" stroke="#fff" />
//                 <YAxis stroke="#fff" />
//                 <Tooltip
//                   contentStyle={{
//                     backgroundColor: "rgba(0,0,0,0.8)",
//                     border: "none",
//                     borderRadius: "5px",
//                     color: "#fff",
//                   }}
//                   formatter={(value) => [formatCurrency(value), "Amount"]}
//                 />
//                 <Legend />
//                 <Line
//                   type="monotone"
//                   dataKey="totalAmount"
//                   stroke="url(#lineGradient)"
//                   strokeWidth={3}
//                   name="Total Amount"
//                   dot={{ stroke: GRADIENT_COLORS.pink, strokeWidth: 2, fill: "#fff", r: 4 }}
//                   activeDot={{ r: 8, stroke: GRADIENT_COLORS.pink, strokeWidth: 2, fill: "#fff" }}
//                   animationDuration={2000}
//                   animationBegin={300}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>

//         {/* Chart 3: Pie Chart - Verification Status */}
//         <motion.div
//           className="chart-card"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.5, delay: 0.2 }}
//           whileHover={{ y: -5 }}
//           style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//         >
//           <h3>Payment Verification Status</h3>
//           <div className="chart-container">
//             <ResponsiveContainer width="100%" height={300}>
//               <PieChart>
//                 <defs>
//                   <linearGradient id="pieGradient1" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.9} />
//                     <stop offset="100%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.9} />
//                   </linearGradient>
//                   <linearGradient id="pieGradient2" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.9} />
//                     <stop offset="100%" stopColor={GRADIENT_COLORS.pink} stopOpacity={0.9} />
//                   </linearGradient>
//                 </defs>
//                 <Pie
//                   data={pieChartData}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={true}
//                   outerRadius={100}
//                   innerRadius={60}
//                   fill="#8884d8"
//                   dataKey="value"
//                   nameKey="name"
//                   label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                   animationDuration={2000}
//                   animationBegin={300}
//                 >
//                   <Cell fill="url(#pieGradient1)" />
//                   <Cell fill="url(#pieGradient2)" />
//                 </Pie>
//                 <Tooltip
//                   contentStyle={{
//                     backgroundColor: "rgba(0,0,0,0.8)",
//                     border: "none",
//                     borderRadius: "5px",
//                     color: "#fff",
//                   }}
//                   formatter={(value) => [`${value}`, "Count"]}
//                 />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>

//         {/* Chart 4: Area Chart - Cumulative Revenue */}
//         <motion.div
//           className="chart-card"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.5, delay: 0.3 }}
//           whileHover={{ y: -5 }}
//           style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//         >
//           <h3>Cumulative Revenue</h3>
//           <div className="chart-container">
//             <ResponsiveContainer width="100%" height={300}>
//               <AreaChart
//                 data={chartData.map((item, index, array) => {
//                   let cumulativeAmount = 0
//                   for (let i = 0; i <= index; i++) {
//                     cumulativeAmount += array[i].totalAmount
//                   }
//                   return { ...item, cumulativeAmount }
//                 })}
//                 margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
//               >
//                 <defs>
//                   <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.8} />
//                     <stop offset="95%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.2} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
//                 <XAxis dataKey="date" stroke="#fff" />
//                 <YAxis stroke="#fff" />
//                 <Tooltip
//                   contentStyle={{
//                     backgroundColor: "rgba(0,0,0,0.8)",
//                     border: "none",
//                     borderRadius: "5px",
//                     color: "#fff",
//                   }}
//                   formatter={(value) => [formatCurrency(value), "Cumulative Amount"]}
//                 />
//                 <Legend />
//                 <Area
//                   type="monotone"
//                   dataKey="cumulativeAmount"
//                   stroke={GRADIENT_COLORS.blue}
//                   strokeWidth={2}
//                   fill="url(#areaGradient)"
//                   name="Cumulative Revenue"
//                   animationDuration={2000}
//                   animationBegin={300}
//                 />
//               </AreaChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>

//         {/* Chart 5: Radar Chart - Payment Categories */}
//         <motion.div
//           className="chart-card"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.5, delay: 0.4 }}
//           whileHover={{ y: -5 }}
//           style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//         >
//           <h3>Payment Amount Categories</h3>
//           <div className="chart-container">
//             <ResponsiveContainer width="100%" height={300}>
//               <RadarChart outerRadius={90} data={radarChartData}>
//                 <defs>
//                   <linearGradient id="radarGradient" x1="0" y1="0" x2="1" y2="1">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.7} />
//                     <stop offset="100%" stopColor={GRADIENT_COLORS.pink} stopOpacity={0.7} />
//                   </linearGradient>
//                 </defs>
//                 <PolarGrid stroke="rgba(255,255,255,0.3)" />
//                 <PolarAngleAxis dataKey="subject" stroke="#fff" />
//                 <PolarRadiusAxis stroke="#fff" />
//                 <Radar
//                   name="Payments"
//                   dataKey="A"
//                   stroke={GRADIENT_COLORS.purple}
//                   fill="url(#radarGradient)"
//                   fillOpacity={0.6}
//                   animationDuration={2000}
//                   animationBegin={300}
//                 />
//                 <Tooltip
//                   contentStyle={{
//                     backgroundColor: "rgba(0,0,0,0.8)",
//                     border: "none",
//                     borderRadius: "5px",
//                     color: "#fff",
//                   }}
//                 />
//                 <Legend />
//               </RadarChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>

//         {/* Chart 6: Scatter Chart - Payment Amounts Distribution */}
//         <motion.div
//           className="chart-card"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.5, delay: 0.5 }}
//           whileHover={{ y: -5 }}
//           style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
//         >
//           <h3>Payment Amounts Distribution</h3>
//           <div className="chart-container">
//             <ResponsiveContainer width="100%" height={300}>
//               <ScatterChart margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                 <defs>
//                   <linearGradient id="scatterGradient" x1="0" y1="0" x2="1" y2="1">
//                     <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.8} />
//                     <stop offset="100%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.8} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
//                 <XAxis type="number" dataKey="x" name="Payment Index" stroke="#fff" />
//                 <YAxis type="number" dataKey="y" name="Amount" stroke="#fff" />
//                 <Tooltip
//                   contentStyle={{
//                     backgroundColor: "rgba(0,0,0,0.8)",
//                     border: "none",
//                     borderRadius: "5px",
//                     color: "#fff",
//                   }}
//                   formatter={(value, name) => [
//                     name === "y" ? formatCurrency(value) : value,
//                     name === "y" ? "Amount" : "Index",
//                   ]}
//                   cursor={{ strokeDasharray: "3 3" }}
//                 />
//                 <Legend />
//                 <Scatter
//                   name="Payments"
//                   data={scatterChartData}
//                   fill="url(#scatterGradient)"
//                   shape="circle"
//                   animationDuration={2000}
//                   animationBegin={300}
//                 />
//               </ScatterChart>
//             </ResponsiveContainer>
//           </div>
//         </motion.div>
//       </div>

//       <div className="table-section">
//         <h2>Recent Transactions</h2>
//         <div className="table-container">
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>Order ID</th>
//                 <th>Payment ID</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Date</th>
//                 <th>Email</th>
//               </tr>
//             </thead>
//             <tbody>
//               <AnimatePresence>
//                 {paymentData.map((payment, index) => (
//                   <motion.tr
//                     key={payment.order_id || index}
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -10 }}
//                     transition={{ duration: 0.3, delay: index * 0.05 }}
//                     whileHover={{ backgroundColor: "rgba(65, 88, 208, 0.05)" }}
//                   >
//                     <td>{payment.order_id}</td>
//                     <td>{payment.payment_id}</td>
//                     <td>{formatCurrency(payment.amount  )}</td>
//                     <td>
//                       <span className={`status-badge ${payment.verified ? "verified" : "not-verified"}`}>
//                         {payment.verified ? "Verified" : "Not Verified"}
//                       </span>
//                     </td>
//                     <td>{formatDate(payment.created_at)}</td>
//                     <td>{payment.email || "N/A"}</td>
//                   </motion.tr>
//                 ))}
//               </AnimatePresence>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <style jsx>{`
//         /* Dashboard Styles */
//         .dashboard-container {
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 20px;
//           background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
//           color: #fff;
//           min-height: 100vh;
//         }

//         .dashboard-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 30px;
//           padding-bottom: 15px;
//           border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//         }

//         .dashboard-header h1 {
//           font-size: 32px;
//           font-weight: 600;
//           color: #fff;
//           margin: 0;
//           text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
//           background: linear-gradient(to right, #4158D0, #C850C0);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         }

//         .date-range {
//           font-size: 14px;
//           color: rgba(255, 255, 255, 0.7);
//         }

//         .dashboard-tabs {
//           display: flex;
//           margin-bottom: 25px;
//           border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//         }

//         .dashboard-tabs button {
//           padding: 12px 20px;
//           background: none;
//           border: none;
//           font-size: 16px;
//           font-weight: 500;
//           color: rgba(255, 255, 255, 0.7);
//           cursor: pointer;
//           transition: all 0.3s ease;
//           position: relative;
//         }

//         .dashboard-tabs button.active {
//           color: #fff;
//         }

//         .dashboard-tabs button.active::after {
//           content: '';
//           position: absolute;
//           bottom: -1px;
//           left: 0;
//           width: 100%;
//           height: 3px;
//           background: linear-gradient(to right, #4158D0, #C850C0);
//         }

//         .dashboard-stats {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
//           gap: 20px;
//           margin-bottom: 30px;
//         }

//         .stat-card {
//           background: rgba(255, 255, 255, 0.05);
//           backdrop-filter: blur(10px);
//           border-radius: 15px;
//           padding: 20px;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
//           transition: transform 0.3s ease;
//           border: 1px solid rgba(255, 255, 255, 0.1);
//         }

//         .stat-card:hover {
//           transform: translateY(-5px);
//           border: 1px solid rgba(255, 255, 255, 0.2);
//         }

//         .stat-card h3 {
//           font-size: 16px;
//           color: rgba(255, 255, 255, 0.7);
//           margin-top: 0;
//           margin-bottom: 10px;
//         }

//         .stat-value {
//           font-size: 28px;
//           font-weight: 600;
//           color: #fff;
//           margin: 0;
//           background: linear-gradient(to right, #4158D0, #C850C0);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         }

//         .stat-description {
//           font-size: 14px;
//           color: rgba(255, 255, 255, 0.7);
//           margin: 5px 0 0;
//         }

//         .charts-container {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
//           gap: 20px;
//           margin-bottom: 30px;
//         }

//         @media (max-width: 768px) {
//           .charts-container {
//             grid-template-columns: 1fr;
//           }
//         }

//         .chart-card {
//           background: rgba(255, 255, 255, 0.05);
//           backdrop-filter: blur(10px);
//           border-radius: 15px;
//           padding: 20px;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
//           border: 1px solid rgba(255, 255, 255, 0.1);
//           transition: transform 0.3s ease;
//         }

//         .chart-card:hover {
//           transform: translateY(-5px);
//           border: 1px solid rgba(255, 255, 255, 0.2);
//         }

//         .chart-card h3 {
//           font-size: 18px;
//           color: #fff;
//           margin-top: 0;
//           margin-bottom: 15px;
//           text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//         }

//         .chart-container {
//           height: 300px;
//         }

//         .table-section {
//           background: rgba(255, 255, 255, 0.05);
//           backdrop-filter: blur(10px);
//           border-radius: 15px;
//           padding: 20px;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
//           margin-bottom: 30px;
//           border: 1px solid rgba(255, 255, 255, 0.1);
//         }

//         .table-section h2 {
//           font-size: 22px;
//           color: #fff;
//           margin-top: 0;
//           margin-bottom: 15px;
//           text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//         }

//         .table-container {
//           overflow-x: auto;
//         }

//         .data-table {
//           width: 100%;
//           border-collapse: collapse;
//           font-size: 14px;
//           color: #fff;
//         }

//         .data-table th {
//           background: rgba(255, 255, 255, 0.1);
//           padding: 12px 15px;
//           text-align: left;
//           font-weight: 600;
//           color: #fff;
//           border-bottom: 2px solid rgba(255, 255, 255, 0.1);
//         }

//         .data-table td {
//           padding: 12px 15px;
//           border-bottom: 1px solid rgba(255, 255, 255, 0.05);
//         }

//         .data-table tr:hover {
//           background: rgba(255, 255, 255, 0.05);
//         }

//         .status-badge {
//           display: inline-block;
//           padding: 4px 12px;
//           border-radius: 20px;
//           font-size: 12px;
//           font-weight: 500;
//         }

//         .status-badge.verified {
//           background: linear-gradient(to right, #4158D0, #4e81d9);
//           color: #fff;
//         }

//         .status-badge.not-verified {
//           background: linear-gradient(to right, #C850C0, #d45db3);
//           color: #fff;
//         }

//         /* Animation for charts */
//         @keyframes pulse {
//           0% { opacity: 0.7; }
//           50% { opacity: 1; }
//           100% { opacity: 0.7; }
//         }

//         .recharts-surface {
//           animation: pulse 3s infinite ease-in-out;
//         }
//       `}</style>
//     </div>
//   )
// }

// export default Dashboard
import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  AreaChart,
  Area,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { motion, AnimatePresence } from "framer-motion";

const Dashboard = () => {
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [mockData, setMockData] = useState(false);

  // Gradient colors for charts
  const GRADIENT_COLORS = {
    blue: "#4158D0",
    purple: "#C850C0",
    pink: "#FFCC70",
    orange: "#FF6B6B",
    teal: "#4ECDC4",
  };

  // Define chart colors with gradients
  const COLORS = [
    GRADIENT_COLORS.blue,
    GRADIENT_COLORS.purple,
    GRADIENT_COLORS.pink,
    GRADIENT_COLORS.orange,
    GRADIENT_COLORS.teal,
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch("https://hsbubackend.tdtlworld.com/formdata/payment/");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        // Check if data is empty or has issues
        if (!data || data.length === 0) {
          console.warn("API returned empty data, using mock data");
          setMockData(true);
          // Use the sample data provided by the user
          setPaymentData([
            {
              order_id: "order_QMUK4vniY1UvBI",
              payment_id: "pay_QMUKRC9R1Mk63s",
              signature: "b3df23c3059669cdc6bd0bdf604f3337927c390863e4b04c0f6fcf97668b87f9",
              amount: 10000,
              verified: true,
              created_at: "2025-04-24T08:16:04.770284Z",
              mobile: null,
              name: null,
              email: null,
              program_id: null,
            },
            {
              order_id: "order_QMUK4vniY1UvBI",
              payment_id: "pay_QMUKRC9R1Mk63s",
              signature: "b3df23c3059669cdc6bd0bdf604f3337927c390863e4b04c0f6fcf97668b87f9",
              amount: 15000,
              verified: true,
              created_at: "2025-04-24T07:35:12.776790Z",
              mobile: null,
              name: null,
              email: null,
              program_id: null,
            },
          ]);
        } else {
          setPaymentData(data);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
        setMockData(true);
        // Use the sample data provided by the user
        setPaymentData([
          {
            order_id: "order_QMUK4vniY1UvBI",
            payment_id: "pay_QMUKRC9R1Mk63s",
            signature: "b3df23c3059669cdc6bd0bdf604f3337927c390863e4b04c0f6fcf97668b87f9",
            amount: 10000,
            verified: true,
            created_at: "2025-04-24T08:16:04.770284Z",
            mobile: null,
            name: null,
            email: null,
            program_id: null,
          },
          {
            order_id: "order_QMUK4vniY1UvBI",
            payment_id: "pay_QMUKRC9R1Mk63s",
            signature: "b3df23c3059669cdc6bd0bdf604f3337927c390863e4b04c0f6fcf97668b87f9",
            amount: 15000,
            verified: true,
            created_at: "2025-04-24T07:35:12.776790Z",
            mobile: null,
            name: null,
            email: null,
            program_id: null,
          },
        ]);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Generate dates for the past week if we're using mock data
  const generateMockDates = () => {
    const dates = [];
    const today = new Date();

    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      dates.push(date.toISOString());
    }

    return dates;
  };

  // Process data for charts
  const processDataForCharts = () => {
    if (mockData) {
      // Generate mock data for charts with the sample payment
      const mockDates = generateMockDates();
      return mockDates.map((date, index) => {
        // Create varying amounts based on the index
        const amount = (paymentData[0].amount  ) * (0.5 + Math.random() * 0.8);
        return {
          date: new Date(date).toLocaleDateString(),
          count: index === 3 ? 2 : 1, // Add a spike on day 3
          totalAmount: amount,
        };
      });
    }

    // Group payments by date
    const paymentsByDate = paymentData.reduce((acc, payment) => {
      const date = new Date(payment.created_at).toLocaleDateString();
      if (!acc[date]) {
        acc[date] = { date, count: 0, totalAmount: 0 };
      }
      acc[date].count += 1;
      acc[date].totalAmount += payment.amount  ; // Convert to dollars/rupees
      return acc;
    }, {});

    // Convert to array for charts
    return Object.values(paymentsByDate);
  };

  // Process data for pie chart (payment verification status)
  const processDataForPieChart = () => {
    const verifiedCount = paymentData.filter((payment) => payment.verified).length;
    const notVerifiedCount = paymentData.length - verifiedCount;

    return [
      { name: "Verified", value: verifiedCount || 1 },
      { name: "Not Verified", value: notVerifiedCount || 0 },
    ];
  };

  // Process data for radar chart (payment amounts by category)
  const processDataForRadarChart = () => {
    // For demo purposes, we'll create categories based on amount ranges
    const categories = {
      "Small (<1000)": 0,
      "Medium (1000-5000)": 0,
      "Large (5000-10000)": 0,
      "X-Large (>10000)": 0,
    };

    paymentData.forEach((payment) => {
      const amount = payment.amount  ;
      if (amount < 1000) {
        categories["Small (<1000)"] += 1;
      } else if (amount < 5000) {
        categories["Medium (1000-5000)"] += 1;
      } else if (amount < 10000) {
        categories["Large (5000-10000)"] += 1;
      } else {
        categories["X-Large (>10000)"] += 1;
      }
    });

    // Ensure we have at least one value in each category for mock data
    if (mockData) {
      categories["X-Large (>10000)"] = 1;
    }

    return Object.keys(categories).map((key) => ({
      subject: key,
      A: categories[key],
      fullMark: paymentData.length,
    }));
  };

  // Process data for scatter chart
  const processDataForScatterChart = () => {
    if (mockData) {
      // Generate mock scatter data
      return Array.from({ length: 10 }, (_, i) => ({
        x: i + 1,
        y: (paymentData[0].amount  ) * (0.7 + Math.random() * 0.6),
        z: Math.random() > 0.3 ? 200 : 100,
      }));
    }

    return paymentData.map((payment, index) => ({
      x: index + 1,
      y: payment.amount  ,
      z: payment.verified ? 200 : 100,
    }));
  };

  // Calculate total revenue
  const calculateTotalRevenue = () => {
    return paymentData.reduce((total, payment) => total + payment.amount  , 0).toFixed(2);
  };

  // Calculate average transaction value
  const calculateAverageTransaction = () => {
    if (paymentData.length === 0) return 0;
    return (
      paymentData.reduce((total, payment) => total + payment.amount  , 0) / paymentData.length
    ).toFixed(2);
  };

  // Format date for display
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Generate skeleton data for charts when loading
  const generateSkeletonData = () => {
    return Array.from({ length: 7 }, (_, i) => ({
      date: `Day ${i + 1}`,
      count: Math.floor(Math.random() * 3) + 1,
      totalAmount: Math.floor(Math.random() * 5000) + 1000,
    }));
  };

  // Generate skeleton data for pie chart
  const generateSkeletonPieData = () => {
    return [
      { name: "Category 1", value: 60 },
      { name: "Category 2", value: 40 },
    ];
  };

  // Generate skeleton data for radar chart
  const generateSkeletonRadarData = () => {
    return [
      { subject: "Category A", A: 80, fullMark: 150 },
      { subject: "Category B", A: 120, fullMark: 150 },
      { subject: "Category C", A: 60, fullMark: 150 },
      { subject: "Category D", A: 100, fullMark: 150 },
    ];
  };

  // Generate skeleton data for scatter chart
  const generateSkeletonScatterData = () => {
    return Array.from({ length: 10 }, (_, i) => ({
      x: i + 1,
      y: Math.floor(Math.random() * 5000) + 1000,
      z: 100,
    }));
  };

  // Generate skeleton rows for table
  const generateSkeletonTableRows = () => {
    return Array.from({ length: 5 }, (_, i) => ({
      id: `skeleton-${i}`,
      order_id: `ORD${100000 + i}`,
      payment_id: `PAY${200000 + i}`,
      amount: Math.floor(Math.random() * 100000) + 10000,
      verified: Math.random() > 0.3,
      created_at: new Date().toISOString(),
      email: "user@example.com",
    }));
  };

  if (loading) {
    // Show skeleton UI while loading
    const skeletonChartData = generateSkeletonData();
    const skeletonPieData = generateSkeletonPieData();
    const skeletonRadarData = generateSkeletonRadarData();
    const skeletonScatterData = generateSkeletonScatterData();
    const skeletonTableData = generateSkeletonTableRows();

    return (
      <div className="dashboard-container">
        <header className="dashboard-header">
          <div className="skeleton-text skeleton-title"></div>
          <div className="skeleton-text skeleton-date"></div>
        </header>

        <div className="dashboard-tabs">
          <div className="skeleton-tab"></div>
          <div className="skeleton-tab"></div>
          <div className="skeleton-tab"></div>
        </div>

        <div className="dashboard-stats">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={`stat-skeleton-${index}`} className="stat-card skeleton-card">
              <div className="skeleton-text skeleton-label"></div>
              <div className="skeleton-text skeleton-value"></div>
              <div className="skeleton-text skeleton-description"></div>
            </div>
          ))}
        </div>

        <div className="charts-container">
          {/* Skeleton Bar Chart */}
          <div className="chart-card skeleton-card">
            <div className="skeleton-text skeleton-chart-title"></div>
            <div className="chart-container skeleton-chart">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={skeletonChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                  <XAxis dataKey="date" stroke="rgba(255,255,255,0.3)" />
                  <YAxis stroke="rgba(255,255,255,0.3)" />
                  <Tooltip />
                  <Bar dataKey="count" fill="rgba(255,255,255,0.2)" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Skeleton Line Chart */}
          <div className="chart-card skeleton-card">
            <div className="skeleton-text skeleton-chart-title"></div>
            <div className="chart-container skeleton-chart">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={skeletonChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                  <XAxis dataKey="date" stroke="rgba(255,255,255,0.3)" />
                  <YAxis stroke="rgba(255,255,255,0.3)" />
                  <Line type="monotone" dataKey="totalAmount" stroke="rgba(255,255,255,0.3)" dot={false} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Skeleton Pie Chart */}
          <div className="chart-card skeleton-card">
            <div className="skeleton-text skeleton-chart-title"></div>
            <div className="chart-container skeleton-chart">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={skeletonPieData}
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    fill="rgba(255,255,255,0.2)"
                    dataKey="value"
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Skeleton Area Chart */}
          <div className="chart-card skeleton-card">
            <div className="skeleton-text skeleton-chart-title"></div>
            <div className="chart-container skeleton-chart">
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={skeletonChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                  <XAxis dataKey="date" stroke="rgba(255,255,255,0.3)" />
                  <YAxis stroke="rgba(255,255,255,0.3)" />
                  <Area
                    type="monotone"
                    dataKey="totalAmount"
                    stroke="rgba(255,255,255,0.3)"
                    fill="rgba(255,255,255,0.1)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Skeleton Radar Chart */}
          <div className="chart-card skeleton-card">
            <div className="skeleton-text skeleton-chart-title"></div>
            <div className="chart-container skeleton-chart">
              <ResponsiveContainer width="100%" height={300}>
                <RadarChart outerRadius={90} data={skeletonRadarData}>
                  <PolarGrid stroke="rgba(255,255,255,0.1)" />
                  <PolarAngleAxis dataKey="subject" stroke="rgba(255,255,255,0.3)" />
                  <Radar
                    name="Skeleton"
                    dataKey="A"
                    stroke="rgba(255,255,255,0.3)"
                    fill="rgba(255,255,255,0.1)"
                    fillOpacity={0.6}
                  />
                </RadarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Skeleton Scatter Chart */}
          <div className="chart-card skeleton-card">
            <div className="skeleton-text skeleton-chart-title"></div>
            <div className="chart-container skeleton-chart">
              <ResponsiveContainer width="100%" height={300}>
                <ScatterChart margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                  <XAxis type="number" dataKey="x" name="Index" stroke="rgba(255,255,255,0.3)" />
                  <YAxis type="number" dataKey="y" name="Amount" stroke="rgba(255,255,255,0.3)" />
                  <Scatter name="Skeleton" data={skeletonScatterData} fill="rgba(255,255,255,0.3)" />
                </ScatterChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <div className="table-section skeleton-card">
          <div className="skeleton-text skeleton-table-title"></div>
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Payment ID</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {skeletonTableData.map((row, index) => (
                  <tr key={`skeleton-row-${index}`} className="skeleton-row">
                    <td>
                      <div className="skeleton-cell"></div>
                    </td>
                    <td>
                      <div className="skeleton-cell"></div>
                    </td>
                    <td>
                      <div className="skeleton-cell"></div>
                    </td>
                    <td>
                      <div className="skeleton-badge"></div>
                    </td>
                    <td>
                      <div className="skeleton-cell"></div>
                    </td>
                    <td>
                      <div className="skeleton-cell"></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Loading dashboard data...</p>
        </div>

        <style jsx="true">{`
          /* Dashboard Styles */
          .dashboard-container {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            max-width: 1400px;
            margin: 0 auto;
            padding: 20px;
            background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
            color: #fff;
            min-height: 100vh;
            position: relative;
          }

          .dashboard-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .dashboard-tabs {
            display: flex;
            margin-bottom: 25px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .skeleton-tab {
            width: 100px;
            height: 40px;
            background: rgba(255, 255, 255, 0.1);
            margin-right: 10px;
            border-radius: 4px;
          }

          .dashboard-stats {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 20px;
            margin-bottom: 30px;
          }

          .skeleton-card {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 15px;
            padding: 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            position: relative;
            overflow: hidden;
          }

          .skeleton-card::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 0,
              rgba(255, 255, 255, 0.05) 20%,
              rgba(255, 255, 255, 0.1) 60%,
              rgba(255, 255, 255, 0)
            );
            animation: shimmer 2s infinite;
          }

          @keyframes shimmer {
            100% {
              transform: translateX(100%);
            }
          }

          .skeleton-text {
            height: 14px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            margin-bottom: 10px;
          }

          .skeleton-title {
            width: 300px;
            height: 32px;
          }

          .skeleton-date {
            width: 150px;
            height: 14px;
          }

          .skeleton-label {
            width: 70%;
            height: 16px;
          }

          .skeleton-value {
            width: 50%;
            height: 28px;
            margin-top: 10px;
          }

          .skeleton-description {
            width: 60%;
            height: 14px;
            margin-top: 10px;
          }

          .skeleton-chart-title {
            width: 200px;
            height: 18px;
            margin-bottom: 20px;
          }

          .skeleton-table-title {
            width: 200px;
            height: 22px;
            margin-bottom: 20px;
          }

          .charts-container {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
            gap: 20px;
            margin-bottom: 30px;
          }

          @media (max-width: 768px) {
            .charts-container {
              grid-template-columns: 1fr;
            }
          }

          .chart-container {
            height: 300px;
          }

          .skeleton-chart {
            opacity: 0.5;
          }

          .skeleton-row {
            height: 50px;
          }

          .skeleton-cell {
            height: 14px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            width: 80%;
          }

          .skeleton-badge {
            height: 24px;
            width: 80px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 12px;
          }

          .loading-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(15, 12, 41, 0.7);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 10;
            backdrop-filter: blur(5px);
          }

          .loading-spinner {
            border: 4px solid rgba(255, 255, 255, 0.1);
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border-left-color: #C850C0;
            border-top-color: #4158D0;
            animation: spin 1s linear infinite;
            margin-bottom: 20px;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .data-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
            color: #fff;
          }

          .data-table th {
            background: rgba(255, 255, 255, 0.1);
            padding: 12px 15px;
            text-align: left;
            font-weight: 600;
            color: #fff;
            border-bottom: 2px solid rgba(255, 255, 255, 0.1);
          }

          .data-table td {
            padding: 12px 15px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          }
        `}</style>
      </div>
    );
  }

  if (error && !mockData) {
    return (
      <div className="dashboard-container error">
        <h2>Error loading data</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Try Again</button>

        <style jsx="true">{`
          .dashboard-container {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            max-width: 1400px;
            margin: 0 auto;
            padding: 20px;
            background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
            color: #fff;
            min-height: 100vh;
          }

          .error {
            text-align: center;
            padding: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
          }

          .error h2 {
            font-size: 28px;
            margin-bottom: 20px;
            background: linear-gradient(to right, #4158D0, #C850C0);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .error p {
            margin-bottom: 30px;
            font-size: 18px;
            max-width: 600px;
          }

          .error button {
            background: linear-gradient(to right, #4158D0, #C850C0);
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 30px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }

          .error button:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
          }
        `}</style>
      </div>
    );
  }

  const chartData = processDataForCharts();
  const pieChartData = processDataForPieChart();
  const radarChartData = processDataForRadarChart();
  const scatterChartData = processDataForScatterChart();

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Payment Analytics Dashboard
        </motion.h1>
        <div className="date-range">
          <span>Last Updated: {new Date().toLocaleString()}</span>
        </div>
      </header>

      <div className="dashboard-tabs">
        <button
          className={activeTab === "overview" ? "active" : ""}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </button>
        <button
          className={activeTab === "transactions" ? "active" : ""}
          onClick={() => setActiveTab("transactions")}
        >
          Transactions
        </button>
        <button
          className={activeTab === "analytics" ? "active" : ""}
          onClick={() => setActiveTab("analytics")}
        >
          Analytics
        </button>
      </div>

      <div className="dashboard-stats">
        {[
          {
            title: "Total Transactions",
            value: paymentData.length,
            description: "All time payments"
          },
          {
            title: "Total Revenue",
            value: formatCurrency(calculateTotalRevenue()),
            description: "All time revenue"
          },
          {
            title: "Average Transaction",
            value: formatCurrency(calculateAverageTransaction()),
            description: "Per transaction"
          },
          {
            title: "Verification Rate",
            value: paymentData.length
              ? `${((paymentData.filter((p) => p.verified).length / paymentData.length) * 100).toFixed(1)}%`
              : "0%",
            description: "Successfully verified"
          }
        ].map((stat, index) => (
          <motion.div
            key={`stat-${index}`}
            className="stat-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ y: -5 }}
            style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
          >
            <h3>{stat.title}</h3>
            <p className="stat-value">{stat.value}</p>
            <p className="stat-description">{stat.description}</p>
          </motion.div>
        ))}
      </div>

      <div className="charts-container">
        {/* Chart 1: Bar Chart - Payment Counts by Date */}
        <motion.div
          className="chart-card"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          whileHover={{ y: -5 }}
          style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
        >
          <h3>Payment Counts by Date</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <defs>
                  <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.8} />
                    <stop offset="100%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.8} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
                <XAxis dataKey="date" stroke="#fff" tick={{ fill: "#fff", fontSize: 12 }} />
                <YAxis stroke="#fff" tick={{ fill: "#fff", fontSize: 12 }} />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(0,0,0,0.8)",
                    border: "none",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  formatter={(value) => [`${value}`, "Count"]}
                  labelStyle={{ color: "#fff", fontWeight: "bold" }}
                />
                <Legend wrapperStyle={{ color: "#fff", fontSize: 12 }} />
                <Bar
                  dataKey="count"
                  fill="url(#barGradient)"
                  name="Number of Payments"
                  animationDuration={2000}
                  animationBegin={300}
                  animationEasing="ease-in-out"
                  radius={[5, 5, 0, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Chart 2: Line Chart - Payment Amounts Over Time */}
        <motion.div
          className="chart-card"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          whileHover={{ y: -5 }}
          style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
        >
          <h3>Payment Amounts Over Time</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <defs>
                  <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.purple} stopOpacity={1} />
                    <stop offset="100%" stopColor={GRADIENT_COLORS.pink} stopOpacity={1} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
                <XAxis dataKey="date" stroke="#fff" tick={{ fill: "#fff", fontSize: 12 }} />
                <YAxis stroke="#fff" tick={{ fill: "#fff", fontSize: 12 }} />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(0,0,0,0.8)",
                    border: "none",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  formatter={(value) => [formatCurrency(value), "Amount"]}
                  labelStyle={{ color: "#fff", fontWeight: "bold" }}
                />
                <Legend wrapperStyle={{ color: "#fff", fontSize: 12 }} />
                <Line
                  type="monotone"
                  dataKey="totalAmount"
                  stroke="url(#lineGradient)"
                  strokeWidth={3}
                  name="Total Amount"
                  dot={{ stroke: GRADIENT_COLORS.pink, strokeWidth: 2, fill: "#fff", r: 4 }}
                  activeDot={{ r: 8, stroke: GRADIENT_COLORS.pink, strokeWidth: 2, fill: "#fff" }}
                  animationDuration={2000}
                  animationBegin={300}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Chart 3: Pie Chart - Verification Status */}
        <motion.div
          className="chart-card"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          whileHover={{ y: -5 }}
          style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
        >
          <h3>Payment Verification Status</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <defs>
                  <linearGradient id="pieGradient1" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.9} />
                    <stop offset="100%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.9} />
                  </linearGradient>
                  <linearGradient id="pieGradient2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.9} />
                    <stop offset="100%" stopColor={GRADIENT_COLORS.pink} stopOpacity={0.9} />
                  </linearGradient>
                </defs>
                <Pie
                  data={pieChartData}
                  cx="50%"
                  cy="50%"
                  labelLine={true}
                  outerRadius={100}
                  innerRadius={60}
                  fill="#8884d8"
                  dataKey="value"
                  nameKey="name"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                  labelStyle={{ fill: "#fff", fontSize: 14, fontWeight: "bold" }}
                  animationDuration={2000}
                  animationBegin={300}
                >
                  <Cell fill="url(#pieGradient1)" />
                  <Cell fill="url(#pieGradient2)" />
                </Pie>
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(0,0,0,0.8)",
                    border: "none",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  formatter={(value) => [`${value}`, "Count"]}
                  labelStyle={{ color: "#fff", fontWeight: "bold" }}
                />
                <Legend wrapperStyle={{ color: "#fff", fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Chart 4: Area Chart - Cumulative Revenue */}
        <motion.div
          className="chart-card"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          whileHover={{ y: -5 }}
          style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
        >
          <h3>Cumulative Revenue</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={300}>
              <AreaChart
                data={chartData.map((item, index, array) => {
                  let cumulativeAmount = 0;
                  for (let i = 0; i <= index; i++) {
                    cumulativeAmount += array[i].totalAmount;
                  }
                  return { ...item, cumulativeAmount };
                })}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <defs>
                  <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.8} />
                    <stop offset="95%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.2} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
                <XAxis dataKey="date" stroke="#fff" tick={{ fill: "#fff", fontSize: 12 }} />
                <YAxis stroke="#fff" tick={{ fill: "#fff", fontSize: 12 }} />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(0,0,0,0.8)",
                    border: "none",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  formatter={(value) => [formatCurrency(value), "Cumulative Amount"]}
                  labelStyle={{ color: "#fff", fontWeight: "bold" }}
                />
                <Legend wrapperStyle={{ color: "#fff", fontSize: 12 }} />
                <Area
                  type="monotone"
                  dataKey="cumulativeAmount"
                  stroke={GRADIENT_COLORS.blue}
                  strokeWidth={2}
                  fill="url(#areaGradient)"
                  name="Cumulative Revenue"
                  animationDuration={2000}
                  animationBegin={300}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Chart 5: Radar Chart - Payment Categories */}
        <motion.div
          className="chart-card"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          whileHover={{ y: -5 }}
          style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
        >
          <h3>Payment Amount Categories</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={300}>
              <RadarChart outerRadius={90} data={radarChartData}>
                <defs>
                  <linearGradient id="radarGradient" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.7} />
                    <stop offset="100%" stopColor={GRADIENT_COLORS.pink} stopOpacity={0.7} />
                  </linearGradient>
                </defs>
                <PolarGrid stroke="rgba(255,255,255,0.3)" />
                <PolarAngleAxis dataKey="subject" stroke="#fff" tick={{ fill: "#fff", fontSize: 11 }} />
                <PolarRadiusAxis stroke="#fff" tick={{ fill: "#fff", fontSize: 11 }} />
                <Radar
                  name="Payments"
                  dataKey="A"
                  stroke={GRADIENT_COLORS.purple}
                  fill="url(#radarGradient)"
                  fillOpacity={0.6}
                  animationDuration={2000}
                  animationBegin={300}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(0,0,0,0.8)",
                    border: "none",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  labelStyle={{ color: "#fff", fontWeight: "bold" }}
                />
                <Legend wrapperStyle={{ color: "#fff", fontSize: 12 }} />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Chart 6: Scatter Chart - Payment Amounts Distribution */}
        <motion.div
          className="chart-card"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          whileHover={{ y: -5 }}
          style={{ boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
        >
          <h3>Payment Amounts Distribution</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={300}>
              <ScatterChart margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <defs>
                  <linearGradient id="scatterGradient" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor={GRADIENT_COLORS.blue} stopOpacity={0.8} />
                    <stop offset="100%" stopColor={GRADIENT_COLORS.purple} stopOpacity={0.8} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
                <XAxis 
                  type="number" 
                  dataKey="x" 
                  name="Payment Index" 
                  stroke="#fff" 
                  tick={{ fill: "#fff", fontSize: 12 }}
                  label={{ value: "Payment Index", position: "insideBottom", fill: "#fff", offset: -5 }}
                />
                <YAxis 
                  type="number" 
                  dataKey="y" 
                  name="Amount" 
                  stroke="#fff" 
                  tick={{ fill: "#fff", fontSize: 12 }}
                  label={{ value: "Amount (₹)", angle: -90, position: "insideLeft", fill: "#fff" }}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "rgba(0,0,0,0.8)",
                    border: "none",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  formatter={(value, name) => [
                    name === "y" ? formatCurrency(value) : value,
                    name === "y" ? "Amount" : "Index",
                  ]}
                  cursor={{ strokeDasharray: "3 3" }}
                  labelStyle={{ color: "#fff", fontWeight: "bold" }}
                />
                <Legend wrapperStyle={{ color: "#fff", fontSize: 12 }} />
                <Scatter
                  name="Payments"
                  data={scatterChartData}
                  fill="url(#scatterGradient)"
                  shape="circle"
                  animationDuration={2000}
                  animationBegin={300}
                />
              </ScatterChart>
            </ResponsiveContainer>
          </div>
        </motion.div>
      </div>

      <div className="table-section">
        <h2>Recent Transactions</h2>
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Payment ID</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              <AnimatePresence>
                {paymentData.map((payment, index) => (
                  <motion.tr
                    key={payment.order_id || index}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    whileHover={{ backgroundColor: "rgba(65, 88, 208, 0.05)" }}
                  >
                    <td>{payment.order_id}</td>
                    <td>{payment.payment_id}</td>
                    <td>{formatCurrency(payment.amount  )}</td>
                    <td>
                      <span className={`status-badge ${payment.verified ? "verified" : "not-verified"}`}>
                        {payment.verified ? "Verified" : "Not Verified"}
                      </span>
                    </td>
                    <td>{formatDate(payment.created_at)}</td>
                    <td>{payment.email || "N/A"}</td>
                  </motion.tr>
                ))}
              </AnimatePresence>
            </tbody>
          </table>
        </div>
      </div>

      <style jsx="true">{`
        /* Dashboard Styles */
        .dashboard-container {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          max-width: 1400px;
          margin: 0 auto;
          padding: 20px;
          background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
          color: #fff;
          min-height: 100vh;
        }

        .dashboard-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          padding-bottom: 15px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .dashboard-header h1 {
          font-size: 32px;
          font-weight: 600;
          color: #fff;
          margin: 0;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          background: linear-gradient(to right, #4158D0, #C850C0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .date-range {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
        }

        .dashboard-tabs {
          display: flex;
          margin-bottom: 25px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .dashboard-tabs button {
          padding: 12px 20px;
          background: none;
          border: none;
          font-size: 16px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.7);
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .dashboard-tabs button.active {
          color: #fff;
        }

        .dashboard-tabs button.active::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(to right, #4158D0, #C850C0);
        }

        .dashboard-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .stat-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 15px;
          padding: 20px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .stat-card:hover {
          transform: translateY(-5px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .stat-card h3 {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.7);
          margin-top: 0;
          margin-bottom: 10px;
        }

        .stat-value {
          font-size: 28px;
          font-weight: 600;
          color: #fff;
          margin: 0;
          background: linear-gradient(to right, #4158D0, #C850C0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .stat-description {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          margin: 5px 0 0;
        }

        .charts-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        @media (max-width: 768px) {
          .charts-container {
            grid-template-columns: 1fr;
          }
        }

        .chart-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 15px;
          padding: 20px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: transform 0.3s ease;
        }

        .chart-card:hover {
          transform: translateY(-5px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .chart-card h3 {
          font-size: 18px;
          color: #fff;
          margin-top: 0;
          margin-bottom: 15px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .chart-container {
          height: 300px;
        }

        .table-section {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 15px;
          padding: 20px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          margin-bottom: 30px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .table-section h2 {
          font-size: 22px;
          color: #fff;
          margin-top: 0;
          margin-bottom: 15px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .table-container {
          overflow-x: auto;
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
          color: #fff;
        }

        .data-table th {
          background: rgba(255, 255, 255, 0.1);
          padding: 12px 15px;
          text-align: left;
          font-weight: 600;
          color: #fff;
          border-bottom: 2px solid rgba(255, 255, 255, 0.1);
        }

        .data-table td {
          padding: 12px 15px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }

        .data-table tr:hover {
          background: rgba(255, 255, 255, 0.05);
        }

        .status-badge {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }

        .status-badge.verified {
          background: linear-gradient(to right, #4158D0, #4e81d9);
          color: #fff;
        }

        .status-badge.not-verified {
          background: linear-gradient(to right, #C850C0, #d45db3);
          color: #fff;
        }

        /* Animation for charts */
        @keyframes pulse {
          0% { opacity: 0.7; }
          50% { opacity: 1; }
          100% { opacity: 0.7; }
        }

        .recharts-surface {
          animation: pulse 3s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Dashboard;